import { render, staticRenderFns } from "./FilesSidebarTab.vue?vue&type=template&id=6b69fc23"
import script from "./FilesSidebarTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilesSidebarTab.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports